<section class="section-welcome container">
    <div class="left">
        <h1>É importante que você conheça seus direitos e saiba como exercê-los.</h1>
        <p>Você tem o direito de solicitar e obter a confirmação da existência de tratamento e, caso afirmativo, de acesso aos seus dados pessoais tratados por nós como controladores, ou seja, como empresa responsável pelas decisões sobre o referido tratamento.</p>
      <button class="col-xs-6 m-1" id="btn-conhecaSeusDireitos-redirect" (click)="irParaRelatorio()">Acesse seus dados</button>
      <button class="col-xs-6 m-1" id="btn-acompanheSolicitacoes-redirect" style="background-color:#1d4f91" (click)="irParaHistSolicitacoes()">Acompanhe suas solicitações</button>
    </div>
    <div class="right hidden-xs">
        <img src="assets/illustration-notebook.svg" alt="Ilustração - Conheça seus direitos">
    </div>
</section>
<div class="gray-content">
    <h2 class="hidden-xs container">Seus dados, seus direitos</h2>
    <h2 class="show-xs-only">Conheça todos seus direitos</h2>
    <p class="note container">A lei de proteção de dados garante que seus dados pessoais sejam usados de maneira adequada e legal pelas organizações com as quais você os compartilha. Isso significa que você tem vários direitos em relação aos seus dados pessoais, incluindo:</p>
    <div class="cards-list container">
        <div class="card-area" *ngFor="let card of cardList">
            <app-card-link [cardTitle]="card.titulo" [cardDescription]="card.descricao" [cardLink]="card.link"></app-card-link>
        </div>
    </div>
    <div class="footer-note">
        <h4>Hipóteses de tratamento</h4>
        <p>Toda operação realizada com seus dados pessoais está amparada em uma hipótese de tratamento, como a proteção do crédito; o legítimo interesse da Serasa Experian e, conforme o caso, de seus clientes ou parceiros; a execução de contrato; o cumprimento de obrigação regulatória/legal ou o consentimento.
        </p>
        <p>*Os direitos acima serão aplicáveis a depender da hipótese que legitima o tratamento. Esses direitos podem não ser aplicáveis quando a hipótese de tratamento for proteção do crédito ou prevenção a fraudes, por exemplo.
        </p>
    </div>
</div>

<app-footer-lgpd></app-footer-lgpd>
<app-modal-sidebar></app-modal-sidebar>
